import { SupersetClient } from '@aibi-ui/core';
import rison from 'rison';

/** *************************** 前台对话 **************************** */
// 分页获取对话记录列表
export const getChatHistoryListAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/chathistory/record', searchParams });

// 分页获取对话详情
export const getChatHistoryDetailAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/chathistory/detail', searchParams });

// 修改会话标题
export const putChatTitleAPI = async jsonPayload =>
  SupersetClient.put({
    endpoint: '/api/v1/chathistory/record/status',
    jsonPayload,
  });

// 删除对话
export const deleteChatAPI = async id =>
  SupersetClient.delete({ endpoint: `/api/v1/chathistory/record/${id}` });

// 停止回答
export const postStopChatAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: `/api/v1/chat/conversation/stop`,
    jsonPayload,
  });

/**
 * 选择实体
 * @param {Object} jsonPayload
 * @param {Array|null} jsonPayload.content 选择的实体，数组对应每个问题
 * @param {string} jsonPayload.conversation_id 会话id
 * @param {string} jsonPayload.round_id 会话轮次id
 * @returns
 */
export const postChatInteractAPI = jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/chat/interact',
    jsonPayload,
  });

/** 获取当前用户的对话设置 */
export const getChatSettingAPI = async () =>
  SupersetClient.get({ endpoint: '/api/v1/chat/setting' });

/**
 * 修改对话设置
 * @param {Object} jsonPayload
 * @param {boolean} jsonPayload.collaborate_model 是否开启人机协作模式
 */
export const postChatSettingAPI = async jsonPayload =>
  SupersetClient.post({
    endpoint: '/api/v1/chat/setting',
    jsonPayload,
  });

// 点赞||负赞
export const likeChatAPI = async jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/chathistory/like', jsonPayload });

// 分享对话
export const shareConversationAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/chathistory/share', jsonPayload });

// 查看分享的对话
export const getShareConversationAPI = async searchParams =>
  SupersetClient.get({ endpoint: '/api/v1/chathistory/share', searchParams });

// 保存图表
export const postSaveChartAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/chathistory/chart', jsonPayload });

// 查询我创建的看板
export const getDashboardAPI = async () =>
  SupersetClient.get({
    endpoint: '/api/v1/dashboard/',
    searchParams: {
      q: rison.encode({
        filters: [
          {
            col: 'created_by',
            opr: 'dashboard_created_by_me',
            value: true,
          },
        ],
      }),
    },
  });

// 保存到看板
export const postSaveToDashboardAPI = async (slice_id, jsonPayload) =>
  SupersetClient.post({ endpoint: `/api/v1/chart/`, jsonPayload });

// 图表获取表格数据
export const postTransformTableAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/chart/data', jsonPayload });

// 旧图表获取数据
export const postOldTransformTableAPI = async postPayload =>
  SupersetClient.post({ endpoint: '/aibi/explore_json/', postPayload });

/**
 * 文字转语音
 * @param {*} jsonPayload
 * @returns {Promise<import('@aibi-ui/core').JsonResponse<{message: {conversationId: string; audio: string; text: string; roundId: string;}}>>}
 */
export const postTextToSpeechAPI = async jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/speech/toSpeech', jsonPayload });

/** 语音识别获取token */
export const postSpeechToken = async () =>
  SupersetClient.post({ endpoint: '/api/v1/speech/token' });
